import * as React from 'react';

function TelegramIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 24 20" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.65 8.61c6.442-2.823 10.738-4.683 12.888-5.582C20.675.46 21.95.015 22.782 0c.182-.003.591.042.856.259.223.182.285.428.314.601.03.173.066.567.037.875-.332 3.514-1.771 12.041-2.503 15.977-.31 1.665-.92 2.223-1.51 2.278-1.284.119-2.259-.853-3.502-1.672-1.945-1.282-3.043-2.08-4.931-3.331-2.182-1.446-.768-2.24.476-3.54.325-.34 5.98-5.511 6.089-5.98.014-.059.026-.278-.103-.393-.13-.116-.32-.076-.457-.045-.196.045-3.303 2.11-9.322 6.196-.882.609-1.681.905-2.397.89-.789-.017-2.307-.449-3.435-.818-1.384-.452-2.484-.691-2.388-1.46.05-.4.598-.809 1.644-1.227z"
				fill="#F2F3F5"
				fillOpacity={0.9}
			/>
		</svg>
	);
}

export default TelegramIcon;
